<template>
  <div class="device-doorlock">
    <div class="page-search-block">
      <div class="m-b-18">
        <!-- <span class="w-90 inline-block align-r m-r-8">高级筛选：</span> -->
        <div class="inline-block" style="display: flex; align-items: center">
          <span class="w-90 inline-block align-r m-r-8">访客：</span>
          <el-input
            v-model="searchValue"
            class="w-300 m-r-10"
            placeholder="请输入访客名称或手机号查询"
          ></el-input>
          <el-button class="submit-btn" @click="getQuery" type="primary"
            >搜索</el-button
          >
          <el-button @click="reset">重置</el-button>
        </div>
      </div>
    </div>

    <div class="operations">
      <i class="iconfont show-more" :class="isShowMore ? 'wyf-yanjing_kai' : 'wyf-yanjing_bi'" @click="isShowMore = !isShowMore"></i>
      <el-button @click="add" type="warning" v-permission="'add'">添加</el-button>
      <el-button @click="modify" type="warning" v-permission="'edit'" :disabled="options.selection.length!=1">修改</el-button>
      <el-button @click="remove" plain type="warning" v-permission="'delete'" :disabled="options.selection.length === 0">删除</el-button>
    </div>


    <div class="table-list-block">
      <r-table 
        ref="tenantTable"
        :dataSource="tableData"
        :options="options"
        :pagination="pagination"
        @current-change="handlePageChange"
        @row-click="handleRowClick"
      >
        <el-table-column
          label="客户姓名"
          width="100px"
          show-overflow-tooltip
        >
          <template #default="{row}">
            {{isShowMore ? row.visitorName : filterName(row.visitorName)}}
          </template>
        </el-table-column>
        <el-table-column
          label="手机号"
          show-overflow-tooltip
          width="140px"
        >
          <template #default="{row}">
            {{isShowMore ? row.visitorMobile : filterPhone(row.visitorMobile)}}
          </template>
        </el-table-column>
        <el-table-column
          prop="visitorGender"
          label="性别"
          width="100px"
          show-overflow-tooltip
        ></el-table-column>
        <el-table-column
          label="被访人"
          width="100px"
          show-overflow-tooltip
        >
          <template #default="{row}">
            {{isShowMore ? row.intervieweeName : filterName(row.intervieweeName)}}
          </template>
        </el-table-column>
        <el-table-column
          label="被访人手机号"
          show-overflow-tooltip
          width="140px"
        >
          <template #default="{row}">
            {{isShowMore ? row.intervieweePhone : filterPhone(row.intervieweePhone)}}
          </template>
        </el-table-column>
        <el-table-column
          label="访客房源"
          width="120px"
          show-overflow-tooltip
        >
        <template #default="{ row }">
          {{ row.roomName }}
        </template>
        </el-table-column>
        <el-table-column
          label="房源地址"
          show-overflow-tooltip
        >
        <template #default="{ row }">
          {{ row.roomAddress }}
        </template>
        </el-table-column>
        <el-table-column
          label="来访时间"
          width="160px"
          show-overflow-tooltip
        >
        <template #default="{ row }">
          {{ row.arrivalTime }}
        </template>
        </el-table-column>
        <el-table-column
          label="离开时间"
          width="160px"
          show-overflow-tooltip
        >
        <template #default="{ row }">
          {{ row.departureTime }}
        </template>
        </el-table-column>
        <el-table-column
          label="登记时间"
          width="160px"
          show-overflow-tooltip
        >
        <template #default="{ row }">
          {{ row.createTime }}
        </template>
        </el-table-column>
      </r-table>
    </div>
    <el-dialog v-model="dialogVisible" title="访客登记" @close="handleDialogClose" width="70%">
      <el-form :inline="true" :rules="rules" label-width="120px" :model="form" ref="form">
        <el-form-item prop="roomCode" label="来访房源：" style="width: 45%;">
          <el-select style="width: 100px; margin-right: 8px;" v-model="form.roomTypeCode" @change="onRoomTypeChange" :disabled="!!form.id">
            <el-option :label="item.roomTypeName" :value="item.id" v-for="(item, i) of roomTypeList" :key="i"></el-option>
            <el-option v-if="form.roomTypeName" :label="form.roomTypeName" :value="undefined" />
          </el-select>
          <el-select style="width: 150px;" v-model="form.roomCode" @change="onRoomCodeChange" :disabled="!!form.id">
            <el-option :label="item.roomName" :value="item.roomCode" v-for="(item, i) of roomList" :key="i"></el-option>
            <el-option v-if="form.roomName" :label="form.roomName" :value="form.roomCode" />
          </el-select>
        </el-form-item>
        <el-form-item prop="occupantId" label="受访人：" style="width: 45%;">
          <el-select v-model="form.occupantId" @change="onOccupantIdChange" :disabled="!!form.id">
            <el-option :label="item.occupantName" :value="item.occupantId" v-for="(item, i) of intervieweesList" :key="i"></el-option>
            <el-option v-if="form.intervieweeName" :label="form.intervieweeName" :value="form.occupantId" />
          </el-select>
        </el-form-item>
        <el-form-item prop="visitorIdType" label="访客证件类型：" style="width: 45%;">
          <el-select v-model="form.visitorIdType" :disabled="!!form.id">
            <el-option :label="item.value" :value="item.name" v-for="(item, i) of certTypeList" :key="i"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item prop="visitorName" label="访客姓名：" style="width: 45%;">
          <el-input placeholder="请输入" v-model="form.visitorName" :disabled="!!form.id"></el-input>
        </el-form-item>
        <el-form-item prop="visitorIdNumber" label="证件号码：" style="width: 45%;">
          <el-input placeholder="请输入" v-model="form.visitorIdNumber" :disabled="!!form.id"></el-input>
        </el-form-item>
        <el-form-item prop="visitorMobile" label="手机号：" style="width: 45%;">
          <el-input placeholder="请输入" v-model="form.visitorMobile" :disabled="!!form.id"></el-input>
        </el-form-item>
        <el-form-item prop="arrivalTime" label="来访时间：" style="width: 45%;">
          <el-date-picker
            v-model="form.arrivalTime"
            type="datetime"
            placeholder="请选择来访时间"
            value-format="YYYY-MM-DD HH:mm:ss"
          />
        </el-form-item>
        <el-form-item prop="departureTime" label="离开时间：" style="width: 45%;">
          <el-date-picker
            v-model="form.departureTime"
            type="datetime"
            placeholder="请选择离开时间"
            value-format="YYYY-MM-DD HH:mm:ss"
          />
        </el-form-item>
        <el-form-item prop="visitorPhoto" label="访客照片：" style="width: 45%;">
          <div style="display: flex; flex-direction: column; align-items: center; cursor: pointer;" @click="uploadPic" :style="{
            cursor: form.id ? 'not-allowed' : 'pointer'
          }">
            <img :src="visitorPhotoSrc || require('@/assets/img/addPic.png')" alt="" style="width: 80px;">
            <span>请上传人像正面照</span>
          </div>
        </el-form-item>
      </el-form>
      <div class="footer">
        <el-button type="primary" @click="confirmDialog">确定</el-button>
        <el-button @click="handleDialogClose">取消</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import RTable from "@/components/common/RTable";
import tableMix from "@/components/common/tableListMixin.js";
import { mapActions } from "vuex";
import {formatTime} from "@/utils/index.js";

export default {
  name: "Visitor",
  components: { RTable },
  mixins: [tableMix],
  data() {
    const validateTel = (rule, value, callback) => {
      const reg = /^1[3456789]\d{9}$/;
      if (!reg.test(value)) {
        callback(new Error("请输入正确的手机号"));
      } else {
        callback();
      }
    };
    const validateIdCard = (rule, value, callback) => {
      const certType = this.certTypeList.find(e => e.type == 'certType');
      if(this.form.visitorIdType != certType.name) return callback();
      const reg = /(^\d{15}$)|(^\d{18}$)|(^\d{17}(\d|X|x)$)/;
      if (!reg.test(value)) {
        callback(new Error("请输入正确的证件号码"));
      } else {
        callback();
      }
    };
    return {
      searchValue: "",
      tableData: [],
      pagination: { pageIndex: 1, pageSize: 20, total: 0 },
      dialogVisible: false,
      labelFilter: {
        labelName: "",
      },
      labelList: [],
      selectedLabelList: [],
      selectedTenant: null,
      isShowMore: false,
      rules:{
        roomCode: [
          { required: true, message: '请选择来访房源', trigger: 'blur' }
        ],
        occupantId: [
          { required: true, message: '请选择受访人', trigger: 'blur' }
        ],
        visitorIdType: [
          { required: true, message: '请选择访客证件类型', trigger: 'blur' }
        ],
        visitorName: [
          { required: true, message: '请输入访客姓名', trigger: 'blur' }
        ],
        visitorIdNumber: [
          { required: true, message: '请输入证件号码', trigger: 'blur' },
          { validator: validateIdCard, trigger: 'blur' }
        ],
        visitorMobile: [
          { required: true, message: '请输入手机号', trigger: 'blur' },
          { validator: validateTel, trigger: 'blur' }
        ],
        arrivalTime: [
          { required: true, message: '请选择来访时间', trigger: 'blur' }
        ],
        departureTime: [
          { required: true, message: '请选择离开时间', trigger: 'blur' }
        ],
        visitorPhoto: [
          { required: true, message: '请上传访客照片', trigger: 'blur' }
        ],
      },
      form: {
        roomTypeCode: "",
        roomCode: "",
        occupantId: "",
        visitorIdType: "",
        visitorName: "",
        visitorIdNumber: "",
        visitorMobile: "",
        arrivalTime: "",
        departureTime: "",
        visitorPhoto: "",
        orderCode: "",
      },
      visitorPhotoSrc: "",
      storeId: null,
      roomTypeList: [],
      certTypeList: [],
      roomList: [],
      intervieweesList: [],
    };
  },

  created() {
    const currShopStr = localStorage.getItem('curShop'),
    currShop = currShopStr && JSON.parse(currShopStr);
    this.storeId = currShop?.id;
    this.getQuery();
    this.getCertType();
    this.getRoomType();
    this.$eventBus.on('change-shop', store => {
      this.storeId = store.id;
      this.getQuery();
      this.getRoomType();
    })
  },
  methods: {
    ...mapActions(["fetchData"]),
    uploadPic(){
      if(this.form.id) return;
      const input = document.createElement('input');
      input.type = 'file';
      input.accept = 'image/*';
      input.click();
      input.onchange = (e) => {
        const file = e.target.files[0];
        const formData = new FormData();
        formData.append('photo', file);
        const loading = this.$loading({
          lock: true,
          text: '上传中...',
          spinner: 'el-icon-loading',
          background: 'rgba(0, 0, 0, 0.7)'
        });
        fetch(location.origin + "/saas/api/web/visitor-registration/uploadVisitorPhoto", {
          method: "post",
          body: formData,
          headers: {
            Authorization: localStorage.getItem("Authorization"),
          },
        })
        .then((res) => res.json())
        .then(async ({ code, data, msg }) => {
          if (code == 200) {
            // file转成图片url
            const reader = new FileReader();
            reader.readAsDataURL(file);
            reader.onload = (e) => {
              this.visitorPhotoSrc = e.target.result;
            }
            this.form.visitorPhoto = data;
          }else{
            this.$message.error(msg);
          }
          await this.$nextTick();
          this.$refs.form.validateField("visitorPhoto");
        }).finally(() => {
          loading.close();
        })
      }
    },
    onRoomTypeChange(roomType){
      this.getRoom(roomType);
      this.form.roomCode = "";
    },
    getRoomType(){
      const user = JSON.parse(localStorage.getItem("user"));
      if(user.account === 'admin') return;
      const loading = this.$loading({
        lock: true,
        text: '加载中...',
        spinner: 'el-icon-loading',
        background: 'rgba(0, 0, 0, 0.7)'
      });
      const params = {
        pageSize: 99999999,
        pageNumber: 1,
      };
      if(this.storeId) params.storeId = this.storeId;
      this.fetchData({
        url: 'SAAS.ROOM_TYPE_LIST',
        method: 'get',
        params,
      }).then((res) => {
        this.roomTypeList = res.data;
        this.roomList = [];
      }).finally(() => {
        loading.close();
      })
    },
    getRoom(roomTypeId) {
      const loading = this.$loading({
        lock: true,
        text: '加载中...',
        spinner: 'el-icon-loading',
        background: 'rgba(0, 0, 0, 0.7)'
      });
      const params = {
        pageSize: 99999999,
        pageNumber: 1,
        roomTypeId,
      };
      if(this.storeId) params.storeId = this.storeId;
      this.fetchData({
        url: 'SAAS.ROOM_LIST',
        method: 'get',
        params,
      }).then(res => {
        this.roomList = res?.data || []
      }).finally(() => {
        loading.close();
      })
    },
    getCertType(){
      this.fetchData({
        url: 'RESOURCE.QUERY_DICTS_LIST',
        method: 'get',
        params: {
          types: 'certType'
        },
        flag:true
      }).then( res => {
        if(!res || res.code!=200){
          return false
        }
        this.certTypeList = res.data.certType;
      });
    },
    onRoomCodeChange(roomCode){
      const item = this.roomList.find(item => item.roomCode == roomCode);
      this.getInterviewees(item.id);
      this.form.occupantId = "";
    },
    getInterviewees(roomId){
      const loading = this.$loading({
        lock: true,
        text: '加载中...',
        spinner: 'el-icon-loading',
        background: 'rgba(0, 0, 0, 0.7)'
      });
      this.fetchData({
        url: 'VISITOR.INTERVIEWEES',
        method: 'get',
        params: {roomId},
      }).then( res => {
        if(!res || !res.length){
          this.$message.error('该房源当前无入住人，无法添加访客');
        }
        this.intervieweesList = res || [];
      }).finally(() => {
        loading.close();
      })
    },
    onOccupantIdChange(occupantId){
      const item = this.intervieweesList.find(item => item.occupantId == occupantId);
      this.form.arrivalTime = formatTime(new Date());
      this.form.departureTime = item.departureTime;
      this.form.orderCode = item.orderCode;
    },
    reset(){
      this.searchValue = "";
      this.getQuery();
    },
    confirmDialog(){
      this.$refs.form.validate(async (valid) => {
        if(!valid) return;
        if(new Date(this.form.departureTime) < new Date(this.form.arrivalTime)){
          this.$message.error('离开时间不能早于来访时间');
          return;
        }
        if(new Date(this.form.departureTime) - new Date(this.form.arrivalTime) > 4 * 60 * 60 * 1000){
          await this.$confirm('访客时长超过4小时，确定是否提交？', '提示', {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            type: 'warning'
          });
        }
        const params = {...this.form};
        delete params.roomTypeCode;
        this.fetchData({
          url: "VISITOR.SAVE",
          method: "post",
          headers: { 'Content-Type': 'application/json' },
          params,
        }).then(() => {
          this.handleDialogClose();
          this.selectedTenant = null;
          this.getQuery();
        });
      });
    },
    handleDialogClose(){
      this.dialogVisible = false;
    },
    async add(){
      this.dialogVisible = true;
      await this.$nextTick();
      this.$refs.form.resetFields();
      this.form = {
        roomTypeCode: "",
        roomCode: "",
        occupantId: "",
        visitorIdType: "",
        visitorName: "",
        visitorIdNumber: "",
        visitorMobile: "",
        arrivalTime: "",
        departureTime: "",
        visitorPhoto: "",
        orderCode: "",
      };
      this.roomList = [];
      this.intervieweesList = [];
      this.visitorPhotoSrc = "";
    },
    modify(){
      const row = this.options.selection[0];
      if(new Date(row.departureTime) <= new Date()) return this.$message.error('访客已离开，无法修改');
      this.form = row;
      this.roomList = [];
      this.intervieweesList = [];
      this.visitorPhotoSrc = row.visitorPhotoUrl;
      this.dialogVisible = true;
    },
    remove(){
      let ids = this.options.selection.map(item => Number(item.id))
      this.$confirm(`是否确定删除？删除后不可恢复`).then(() => {
        this.fetchData({
          url: "VISITOR.DELETE",
          method: "post",
          headers: { "Content-Type": "application/json" },
          params: ids,
        }).then(this.getQuery);
      });
    },
    getQuery() {
      const storeId = this.storeId || null;
      const params = {
        searchValue: this.searchValue,
        pageSize: this.pagination.pageSize,
        pageNumber: this.pagination.pageIndex,
      };
      if(storeId){
        params.storeId = storeId;
      }
      this.fetchData({
        url: "VISITOR.PAGE",
        method: "get",
        params,
      }).then((res) => {
        this.tableData = res?.data || [];
        this.pagination.total = res?.rowCount || 0;
      });
    },
    filterName(name){
      if(name && name.length){
        const len = name.length;
        if(len == 1){
          return name;
        }else if(len == 2){
          return name[0] + '*';
        }else{
          return name[0] + new Array(len - 2).fill("*").join('') + name[len - 1]
        }
      }else{
        return name;
      }
    },
    filterPhone(phone){
      return phone && (phone.slice(0, 3) + "****" + phone.slice(7));
    },

  },
};
</script>

<style scoped lang="less">
.device-doorlock {
  background-color: white;
  border-radius: 8px;
  .operations{
    display: flex;
    justify-content: flex-end;
    padding: 0 25px;
    margin-top: 25px;
    .show-more{
      font-size: 20px;
      cursor: pointer;
      margin-right: 8px;
    }
  }
  .statistics {
    display: flex;
    padding: 0 25px;
    .statistics-item {
      flex-grow: 1;
      border-radius: 8px;
      background: #ffffff;
      box-shadow: 1px 1px 2px 0px rgba(82, 90, 102, 0.04),
        2px 2px 8px 0px rgba(82, 90, 102, 0.08);
      padding: 24px 36px 20px;
      margin-right: 44px;
      &:last-child {
        margin-right: 0;
      }
      .item-title {
        font-size: 20px;
        color: #091136;
      }
      .item-count {
        font-size: 40px;
        color: #091136;
        text-align: center;
      }
    }
  }
}
.footer{
  display: flex;
  justify-content: flex-end;
  margin-top: 16px;
}
</style>
<style lang="less">
.renant-modal.el-dialog {
  width: 80% !important;
}
</style>